import { render } from "./EulaContent.vue?vue&type=template&id=1d06946c&scoped=true"
const script = {}

import "./EulaContent.vue?vue&type=style&index=0&id=1d06946c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d06946c"]])

export default __exports__